/* ============================================================================
   BOUTIQUE SHUTTERS — Shop Theme JS (Shopify)
   Cart drawer (live from /cart.js), mobile nav, FAQ accordion, gallery thumbs
   ============================================================================ */

(function () {
  'use strict';

  /* MONEY FORMATTER — uses Shopify's currency format from window if set */
  function formatMoney(cents) {
    const n = (cents / 100).toFixed(2);
    return '$' + n;
  }

  /* CART DRAWER ============================================================ */
  const cartOpenBtn = document.getElementById('cart-open');
  const cartCloseBtn = document.getElementById('cart-close');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartCountEl = document.getElementById('cart-count');
  const cartBodyEl = document.getElementById('cart-body');
  const cartFootEl = document.getElementById('cart-foot');
  const cartSubtotalEl = document.getElementById('cart-subtotal');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (cartOpenBtn) cartOpenBtn.addEventListener('click', openCart);
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  window.BS_openCart = openCart;
  window.BS_closeCart = closeCart;

  /* MOBILE NAV ============================================================= */
  const mobileOpenBtn = document.getElementById('mobile-toggle');
  const mobileCloseBtn = document.getElementById('mobile-close');
  const mobileNav = document.getElementById('mobile-nav');

  function openMobile() {
    if (mobileNav) mobileNav.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobile() {
    if (mobileNav) mobileNav.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (mobileOpenBtn) mobileOpenBtn.addEventListener('click', openMobile);
  if (mobileCloseBtn) mobileCloseBtn.addEventListener('click', closeMobile);

  /* FAQ ACCORDION ========================================================== */
  document.querySelectorAll('.faq__item').forEach(item => {
    const btn = item.querySelector('.faq__toggle');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const wasOpen = item.classList.contains('is-open');
      document.querySelectorAll('.faq__item').forEach(i => i.classList.remove('is-open'));
      if (!wasOpen) item.classList.add('is-open');
      btn.setAttribute('aria-expanded', !wasOpen);
    });
  });

  /* GALLERY THUMBS ========================================================= */
  const mainImg = document.getElementById('gallery-main-img');
  document.querySelectorAll('.gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.getAttribute('data-img');
      if (mainImg && src) mainImg.src = src;
      document.querySelectorAll('.gallery__thumb').forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  /* PRODUCT IMAGE ZOOM / LIGHTBOX ========================================= */
  if (mainImg) {
    mainImg.style.cursor = 'zoom-in';
    const zoom = document.createElement('div');
    zoom.className = 'img-zoom';
    zoom.setAttribute('role', 'dialog');
    zoom.setAttribute('aria-label', 'Product image viewer');
    zoom.innerHTML = '<button type="button" class="img-zoom__close" aria-label="Close">&times;</button><img class="img-zoom__img" alt="">';
    document.body.appendChild(zoom);
    const zoomImg = zoom.querySelector('.img-zoom__img');
    let zoomed = false;
    function openZoom(src) {
      zoomImg.src = src; zoomed = false;
      zoomImg.classList.remove('is-zoomed'); zoomImg.style.transform = '';
      zoom.classList.add('is-open'); document.body.style.overflow = 'hidden';
    }
    function closeZoom() { zoom.classList.remove('is-open'); document.body.style.overflow = ''; }
    function panZoom(e) {
      if (!zoomed) return;
      const r = zoomImg.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width) * 100;
      const y = ((e.clientY - r.top) / r.height) * 100;
      zoomImg.style.transformOrigin = x + '% ' + y + '%';
      zoomImg.style.transform = 'scale(2.4)';
    }
    mainImg.addEventListener('click', () => openZoom(mainImg.currentSrc || mainImg.src));
    zoom.querySelector('.img-zoom__close').addEventListener('click', closeZoom);
    zoom.addEventListener('click', (e) => { if (e.target === zoom) closeZoom(); });
    zoomImg.addEventListener('click', (e) => {
      e.stopPropagation();
      zoomed = !zoomed;
      if (zoomed) { zoomImg.classList.add('is-zoomed'); panZoom(e); }
      else { zoomImg.classList.remove('is-zoomed'); zoomImg.style.transform = ''; }
    });
    zoomImg.addEventListener('mousemove', panZoom);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && zoom.classList.contains('is-open')) closeZoom();
    });
  }

  /* SHOPIFY CART — fetch from /cart.js and render ========================= */
  async function refreshCart() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      renderCart(cart);
    } catch (e) { console.error('Cart refresh failed', e); }
  }
  window.BS_refreshCart = refreshCart;

  function renderCart(cart) {
    if (cartCountEl) cartCountEl.textContent = cart.item_count;

    if (!cartBodyEl) return;
    if (cart.item_count === 0) {
      cartBodyEl.innerHTML = `
        <div class="cart-drawer__empty">
          <p>Your cart is empty.</p>
          <a href="/collections/all" class="btn btn--primary">Shop Blinds</a>
        </div>`;
      if (cartFootEl) cartFootEl.classList.add('hidden');
      return;
    }

    const lines = cart.items.map(item => {
      // Pull configurator properties for spec line
      const props = (item.properties || {});
      const specParts = [];
      if (props['Color']) specParts.push(props['Color']);
      if (props['Width'] && props['Height']) {
        const sz = props['Width'] + ' × ' + props['Height'];
        const isCustom = props['Size Mode'] === 'Custom';
        specParts.push(sz + (isCustom ? ' <span style="color: var(--color-gold-dark); font-weight: 700; font-size: 10px; letter-spacing: 0.06em;">CUSTOM</span>' : ''));
      }
      if (props['Mount']) specParts.push(props['Mount'] + ' mount');
      if (props['Valance']) specParts.push(props['Valance'] + ' valance');
      const spec = specParts.join(' · ');

      const img = item.image ? `<img src="${item.image}" alt="">` : '<div style="width:100%;height:100%;background:var(--color-surface);"></div>';

      return `
        <div class="cart-line" data-key="${item.key}">
          <div class="cart-line__img">${img}</div>
          <div>
            <div class="cart-line__title">${item.product_title}${item.quantity > 1 ? ' × ' + item.quantity : ''}</div>
            <div class="cart-line__spec">${spec}</div>
            <button type="button" class="cart-line__remove" data-remove="${item.key}">Remove</button>
          </div>
          <div class="cart-line__price">${formatMoney(item.final_line_price)}</div>
        </div>`;
    }).join('');

    cartBodyEl.innerHTML = lines;
    if (cartFootEl) cartFootEl.classList.remove('hidden');
    if (cartSubtotalEl) cartSubtotalEl.textContent = formatMoney(cart.total_price);
  }

  async function removeCartItem(key, btn) {
    if (btn) { btn.disabled = true; btn.textContent = 'Removing…'; }
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      if (!res.ok) throw new Error('change failed');
      const cart = await res.json();
      renderCart(cart);
    } catch (e) {
      console.error('Cart remove failed', e);
      if (btn) { btn.disabled = false; btn.textContent = 'Remove'; }
    }
  }

  // Remove buttons are rendered dynamically — one delegated listener handles all
  if (cartBodyEl) {
    cartBodyEl.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-remove]');
      if (!btn) return;
      e.preventDefault();
      removeCartItem(btn.getAttribute('data-remove'), btn);
    });
  }

  // Initial cart load on every page
  refreshCart();

  /* ESC closes any open drawer */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeCart(); closeMobile(); }
  });

})();
